<!--<button (click)="logData()" mat-flat-button>logData</button>-->

<button (click)="sendValidatedFiles()" mat-flat-button style="margin: 20px auto; display: block; color: #fff; background-color: #3d465a; font-weight: 600;">Envoyer les fichiers complétés</button>

<hot-table [hotId]="hotId" [settings]="hotSettings"></hot-table>

<div id="tooltipContent" style="position: absolute; bottom: 10px; left: 0px; right: 0px; text-align: center; z-index: 10000;"></div>
